import { render, staticRenderFns } from "./OriginLoad.vue?vue&type=template&id=16133276"
import script from "./OriginLoad.vue?vue&type=script&lang=js"
export * from "./OriginLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports